import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _eventGuest = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    attendanceStatusUpdatedDate: 'google.protobuf.Timestamp',
    guestDetails: '_guestDetails',
};
var _eventGuests = { guests: '_eventGuest' };
var _formattedAddress = { address: '_address' };
var _formResponse = { inputValues: '_inputValue' };
var _guestDetails = { formResponse: '_formResponse' };
var _guestListPreview = { latestAttendingMembers: '_eventGuests' };
var _inputValue = {
    number: 'google.protobuf.DoubleValue',
    dateTime: 'google.protobuf.Timestamp',
    address: '_formattedAddress',
};
var _listGuestListPreviewsRequest = {};
var _listGuestListPreviewsResponse = { previews: '_guestListPreview' };
var _queryEventGuestsRequest = {};
var _queryEventGuestsResponse = { guests: '_eventGuest' };
function resolveWixEventsGuestsV1EventGuestsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/events-guests',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/events-guests',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-guests',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events-guests',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/events-guests',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-guests',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/events-guests',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a list of guests given the provided paging, filtering, and sorting.
 * Query Event Guests runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `0`
 * For field support for filters and sorting, see [Event Guests: Supported Filters and Sorting](https://dev.wix.com/api/rest/wix-events/event-guests/filter-and-sort).
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryEventGuests(payload) {
    var _a = serializer(_queryEventGuestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryEventGuestsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _eventGuest: _eventGuest,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
    }).fromJSON;
    function __queryEventGuests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.guests.v1.guest',
            method: 'POST',
            methodFqn: 'wix.events.guests.v1.EventGuestsService.QueryEventGuests',
            url: resolveWixEventsGuestsV1EventGuestsServiceUrl({
                protoPath: '/v2/guests/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryEventGuests.fromReq = fromReq;
    __queryEventGuests.__isAmbassador = true;
    return __queryEventGuests;
}
/** Returns a list of guest list summaries per event. */
export function listGuestListPreviews(payload) {
    var _a = serializer(_listGuestListPreviewsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGuestListPreviewsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _eventGuest: _eventGuest,
        _eventGuests: _eventGuests,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _guestListPreview: _guestListPreview,
        _inputValue: _inputValue,
    }).fromJSON;
    function __listGuestListPreviews(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.guests.v1.guest',
            method: 'GET',
            methodFqn: 'wix.events.guests.v1.EventGuestsService.ListGuestListPreviews',
            url: resolveWixEventsGuestsV1EventGuestsServiceUrl({
                protoPath: '/v2/guests/previews',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGuestListPreviews.fromReq = fromReq;
    __listGuestListPreviews.__isAmbassador = true;
    return __listGuestListPreviews;
}
//# sourceMappingURL=http.impl.js.map